export var DrawerPositions;
(function (DrawerPositions) {
    DrawerPositions["Fixed"] = "drawer-fixed";
    DrawerPositions["Absolute"] = "drawer-absolute";
})(DrawerPositions || (DrawerPositions = {}));
//# sourceMappingURL=types.js.map